import { render, staticRenderFns } from "./Materia.vue?vue&type=template&id=9f4096d6&scoped=true"
import script from "./Materia.vue?vue&type=script&lang=js"
export * from "./Materia.vue?vue&type=script&lang=js"
import style0 from "./Materia.vue?vue&type=style&index=0&id=9f4096d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f4096d6",
  null
  
)

export default component.exports